"use client";

import {
	ThemeItem,
	ThemeName,
	ThemeProvider,
} from "@/providers/Theme/ThemeProvider";
import { Theme } from "@itzme1on/uikit";

const themes: ThemeItem[] = [
	{
		name: "light",
		theme: new Theme({
			primary: "#5267e8",
			front: "#404040",
			backgroundBody: "#f2f2f2",
		}),
	},
	{
		name: "dark",
		theme: new Theme({
			primary: "#ffffff",
			background: "#252525",
			backgroundBody: "#202020",
		}),
	},
];

export default function ThemeWrapper({
	children,
	initialThemeName,
}: {
	children: React.ReactNode;
	initialThemeName: ThemeName;
}) {
	return (
		<ThemeProvider initialThemeName={initialThemeName} themes={themes}>
			{children}
		</ThemeProvider>
	);
}
